/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Type_Packing_ListInputs */

const en_document_type_packing_list = /** @type {(inputs: Document_Type_Packing_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packing list`)
};

/**
* | output |
* | --- |
* | "Packing list" |
*
* @param {Document_Type_Packing_ListInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const document_type_packing_list = /** @type {((inputs?: Document_Type_Packing_ListInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Type_Packing_ListInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_document_type_packing_list(inputs)
});